<div class="modal-header">
  <h4 class="modal-title" id="update-attr-modal-basic-title">
    {{ modalTitle }}
  </h4>
  <button
    id="cisterna-details-update-attr-modal-close"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="d('Cross')"
  ></button>
</div>
<div class="modal-body">
  <p>
    <strong>{{ modalQuestion }}</strong>
  </p>
  <p>{{ modalMessage }}</p>
  <form [formGroup]="attributeForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm">
          <label for="center" class="form-label"
            >Usos <span class="text-danger fs-4">*</span></label
          >
          <div class="form-group">
            <app-multi-select
              placeholder="Seleccione Usos."
              [formControl]="usesControl"
              [options]="multiOpts"
            ></app-multi-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    id="cisterna-details-update-attr-modal-cancel"
    type="button"
    class="btn btn-outline-danger"
    (click)="d('Cancel')"
  >
    Cancelar
  </button>
  <button
    id="cisterna-details-update-attr-modal-accept"
    type="button"
    class="btn btn-outline-primary"
    (click)="c('Accept')"
    [disabled]="!attributeForm.valid"
  >
    Aceptar
  </button>
</div>
